import { connect } from 'react-redux';
import Support from 'marketing/common/support';

const mapStateToProps = ({ user }) => {
  return {
    isCreative: user.profile_data.is_creative
  };
}

export default connect(mapStateToProps)(Support);



// WEBPACK FOOTER //
// ./marketing/containers/support.js